module.exports = __webpack_public_path__ + "static/media/gal-10.9865e700.jpeg";